/**
 * Supported contexts
   lowcarbprogram
   grohealth
 * @type {{string}}
 */


var argv = require('minimist')(process.argv.slice(2));
var appcontext = argv.appcontext;
var apponly = argv.apponly;
var runmode = argv.runmode;


/**
if(process.env.NODE_ENV === 'development') {
  appcontext = "lowcarbprogram";
  apponly = true;
  runmode = "development"
}
 **/

module.exports = {
  appcontext: appcontext ? appcontext: "grohealth",
  apponly: apponly ? apponly: null,
  runmode: runmode ? runmode : null
}



//////////////////
// WEBPACK FOOTER
// ./config/app-context.js
// module id = 517
// module chunks = 1